import React from 'react';
import { useSelector } from 'react-redux';
import { convertNumberToCurrency } from '../../../../common/utils';
import { selectConfigSettings } from '../../../../store/slices/config/configSelectors';
import {
  selectPaymentFees,
  selectPaymentSuccessInfo,
} from '../../../../store/slices/payment/paymentSelectors';

/**
 * Renders the Payment check details to the user
 */
const PaymentCompletedCheck = () => {
  const settings = useSelector(selectConfigSettings);
  const paymentFees = useSelector(selectPaymentFees);
  const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);

  const { payTo, mailingAddress, contactEmail, additionalInstructions } =
    settings?.checkPaymentDetails || {};
  const checkTotal = paymentFees.checkTotal;

  if (!settings.checkPaymentDetails) {
    return;
  }

  return (
    <div data-testid="check-wrapper">
      <ul aria-labelledby="check-details">
        <li role="listitem">
          Please make the check out to <b>{payTo}</b>.
        </li>
        <li role="listitem">
          Your unique code is <b>{paymentSuccessInfo?.paymentConfirmation}</b>,
          please ensure this is written on the front of your check.
        </li>
        <li role="listitem">
          Please ensure the exact amount of{' '}
          <b>{convertNumberToCurrency(checkTotal)}</b> is written in the check.
        </li>
        <li role="listitem">
          Please mail all checks to <b>{mailingAddress}</b>.
        </li>
        <li role="listitem">
          Application is not complete until payment is received.
        </li>
        {additionalInstructions?.map((instruction, index) => (
          <li
            role="listitem"
            key={index}
          >
            {instruction}
          </li>
        ))}
      </ul>
      <p>
        For any questions or issues please contact us at{' '}
        <a href={contactEmail}>{contactEmail}</a>
      </p>
    </div>
  );
};

export default PaymentCompletedCheck;
